import { render, staticRenderFns } from "./integralDetailList.vue?vue&type=template&id=0a710f6b&scoped=true"
import script from "./integralDetailList.vue?vue&type=script&lang=js"
export * from "./integralDetailList.vue?vue&type=script&lang=js"
import style0 from "./integralDetailList.vue?vue&type=style&index=0&id=0a710f6b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a710f6b",
  null
  
)

export default component.exports